const Settings = () => {
    return (
        <div>
            <h1>Settings</h1>
            <p>Configure system preferences, manage admin accounts, and update security settings.</p>
        </div>
    );
};

export default Settings;
